// index.js
// require('../utils')
import backbone from 'backbone'
import $ from 'jquery'
import _ from 'underscore'
import owl from 'owl.carousel'

import collapse from 'bootstrap/js/dist/collapse'
import modal from 'bootstrap/js/dist/modal'



import tab from 'bootstrap/js/dist/tab'
// import scrollwatch from 'scrollwatch'
import Cookies from 'js-cookie'
// import vidbacking from 'vidbacking'
// import standalone from './standalone'

// import imagesLoaded from 'imagesloaded'

import CommonView from './CommonView'

// import VisitMap from './VisitMap'
import PremiumView from './premium'


import VideoView from './video'
// import IllustrationView from './views/illustration'
// import AnimationView from './views/animation'
// import BookingsView from './views/bookings'
// import EventsView from './views/events'
// import PremiumView from './views/premium'

// import Basket from './views/basket'

var imagesLoaded = require('imagesloaded')
imagesLoaded.makeJQueryPlugin( $ )

let AppView = Backbone.View.extend({

    el: $('body')[0],

    events: {
        // 'click .pause-slides' : 'pauseSlides',

        'click #hambuger-btn'                            : '_toggleMenu',

        'click .topbar-nav--access a.access'             : '_accessLinkToggleHandler', 
        'click .access-lang-nav-mobile a.access'         : '_accessLinkToggleHandler', 

        'click .header .toggle-search'                   : '_toggleSearch', 

        'submit #mailing-list-signup'                    : 'mailingListSignup',
        'submit #mailing-list-signup-modal'              : 'mailingListSignup',

        'submit .footer-mailing-list-form'               : 'mailingListSignup',

        'submit #access-signup'                          : 'accessSignup',


        'submit .search-form'                            : '_searchFormSubmit',


        'click .language-modal-dialog .btn-close'        : '_closeLangModal',
        'click .language-modal-cta .btn'                 : '_switchLangModal',

        'click .password-modal-dialog .btn-close'        : '_closePwdModal',
        

        'focus .footer--optin input'                     : '_footerOptFormFocus',
        'focus .footer--optin button'                    : '_footerOptFormFocus',

        'focus #mailing-list-signup input'               : '_sidebarOptFormFocus',
        'focus #mailing-list-signup button'              : '_sidebarOptFormFocus',

        'click .close-banner'                            : '_closeCookiesBanner',

    },


    _closePwdModal(e) {
        e.preventDefault()
        // history.back()
        if (document.referrer == "") {
            window.location.href = ajax_client.baseurl
        } else {
            window.history.go(-1)    
        }
        

        return false
    },

    _closeCookiesBanner(e) {
        e.preventDefault()

        this.$el.removeClass('ui-cookies-banner-on')

        Cookies.set('cookies-consent', 1, { expires: 180 })

    },


    _footerOptFormFocus(e) {
        
        $('.footer--optin').addClass('focus')
    },

    _sidebarOptFormFocus(e) {

        $('#mailing-list-signup').addClass('focus')

    },

    access: {
        contrast: 0,
        textScale: 0,
    },

    initialize: function() {

        const _this = this

        // var spektrix_customer = Cookies.get('spektrix_customer')

        // this.observer = new MutationObserver(this.observer_callback)

        // this.observer.observe(this.el, { attributes: true, characterData: true, childList: true, subtree: true })

        // window.addEventListener('message', this.receiveMessage, false)

        $(window).smartresize(_.bind(_this._onWindowResize, _this));        

        let accessSettings = Cookies.get('access-settings')
        if ( accessSettings && accessSettings != 'undefined' ) {
            this.access = JSON.parse(accessSettings)
            // console.log(accessSettings)
            this.accessController()
        }
        
    },


    _closeLangModal(e) {
        e.preventDefault()

        this.$el.removeClass('ui-language-modal-on')

        Cookies.set('lang_opt', 'en', { expires: 180 })
        Cookies.set('wpml_lang', 'en', { expires: 180 })
        
        return false

    },

    _switchLangModal(e) {
        e.preventDefault()

        this.$el.removeClass('ui-language-modal-on')

        Cookies.set('lang_opt', 'cy', { expires: 180 })
        Cookies.set('wpml_lang', 'cy', { expires: 180 })

        document.location.href = $(e.currentTarget).attr('href')
        
        return false
    },

    _searchFormSubmit(e) {
        e.preventDefault()

        let s = $('#s').val().trim()

        if (s.length) {
            window.location.href = ajax_client.baseurl.replace(/\/$/, '') + '/search/' + s
        }

    },


    _toggleSearch( e ) {
        
        e.preventDefault()

        this.$el.toggleClass('ui-search-input-on')

        if ( this.$el.hasClass('ui-search-input-on') ) $('#s').focus()

        return false

    },


    /** Ajax signup */
    mailingListSignup: function(e){

        console.log('SIGNUP')

        var form = $(e.currentTarget)

        var data = {
            ajax: true,
            form: form.serialize(),
            'mailing-list': true
        }

        $.post(location.href, data, function(response){
            

            var response = JSON.parse(response)

            // console.log(response)

            if (form.is('#mailing-list-signup-modal')) {
              
              form.hide()
              $('.block-header').html(response.response)

            } else {
                if ( response.type ) {
                    $('[form-response] .message[data-message-type]').hide()
                    $('[form-response] .message[data-message-type="' + response.type + '"]').show()
                } else {
                    $('[form-response]').html(response.response).show()
                }

                $('.sidebar [form-response]').html(response.response).show()

                if ( 'new_subscribers' == response.type || 'existing_subscribers' == response.type || 'existing_subscribers_update' == response.type ) {
                    form.find('input[type="text"], input[type="email"]').val('')
                }

                if ( response.type != 'error') {
                    // setTimeout(function(){
                    $('.footer--optin').removeClass('focus')
                    $('#mailing-list-signup').removeClass('focus')
                    // }, 2000)
                }
              
            }
            

            if (response.redirect) {
              location.href = response.redirect
            }

        })

        return false
    },


    accessSignup(e) {
        e.preventDefault()

        var form = $(e.currentTarget)

        var data = {
            ajax: true,
            form: form.serialize(),
            'access-form': true
        }

        $.post(location.href, data, function(response){
            

            var response = JSON.parse(response)

            // console.log(response)

            if (form.is('#mailing-list-signup-modal')) {
              
              form.hide()
              $('.block-header').html(response.response)

            } else {
                if ( response.type ) {
                    $('[form-response] .message[data-message-type]').hide()
                    $('[form-response] .message[data-message-type="' + response.type + '"]').show()
                } else {
                    $('[form-response]').html(response.response).show()
                }

                if ( 'new_subscribers' == response.type || 'existing_subscribers' == response.type || 'existing_subscribers_update' == response.type ) {
                    form.find('input[type="text"], input[type="email"]').val('')
                }

                if ( response.type != 'error') {
                    // setTimeout(function(){
                    $('.footer--optin').removeClass('focus')
                    $('#mailing-list-signup').removeClass('focus')
                    // }, 2000)
                }
              
            }
            

            if (response.redirect) {
              location.href = response.redirect
            }

        })

        return false

    },


    _accessLinkToggleHandler(e) {
        e.preventDefault()

        let $a = $(e.currentTarget)

        if ( $a.data('mode') == 'contrast' ) {
            this.access.contrast = !this.access.contrast
        }

        if ( $a.data('mode') == 'text-size-up' && this.access.textScale < 3 ) {
            this.access.textScale += 1
        }

        if ( $a.data('mode') == 'text-size-down' && this.access.textScale > 0 ) {
            this.access.textScale -= 1
        }

        if ( $a.data('mode') == 'text-size-reset' ) {
            this.access.textScale = 0
        }

        Cookies.set('access-settings', JSON.stringify(this.access), { expires: 180 })

        this.accessController()
    },

    _toggleMenu(e) {
        
        let _this = this
        _this.$el.toggleClass('ui-nav-active')

        if ( _this.$el.hasClass('ui-nav-active') ) {
            _this.$el.removeClass('ui-search-input-on')
        }

        return false
    },


    accessController() {

        // console.log(this.access)

        let classes = $('html')[0].className,
            access_classes = []
        
        if ( classes.split(' ').length ) {
           classes.split(' ').forEach( c => {
                if ( c.indexOf('ui-access-') == 0 ) {
                    access_classes.push(c)
                }
            })

           $('html').removeClass(access_classes.join(' '))

        }

        if ( this.access.contrast ) {
           $('html').addClass('ui-access-contrast')
        }

        if ( this.access.textScale != 0 ) {
           $('html').addClass('ui-access-text-scale-' + this.access.textScale )
        }


    },

    observer_callback(mutationsList, observer) {


        // Use traditional 'for loops' for IE 11
        for(var mutation of mutationsList) {

            // if($(mutation.target).is('[data-logged-in-status-customer-email-address]')){
            //     console.log($(mutation.target).text())

            //     var data = $(mutation.target).text()
            //     Cookies.set('spektrix_customer', data, { expires: 180 })

            //     $.get(window.ajax_client.ajax_url, {
            //         'action': 'spektrix_session',
            //         'spektrix_customer': data
            //     }, function(response){
            //         console.log(response)
            //     })
            //     // ajax set session cookie
            // }
        }
    },

    receiveMessage(e) {
        console.log('Hi there!')

        if (e.data.logged_in) {
            var url = new URL(location.href)
        
            if (url.searchParams.get('r')) {
                location.href = url.searchParams.get('r')
            }
        }
    },


    quotes() {

        const _this = this

        $('.quotes-slides').each( (i, item) => {



            $(item).owlCarousel({
                // animateOut: 'fadeOut',
                animateIn: 'fadeIn',
                items: 1,
                nav: true,
                dots: false,
                autoHeight: false,
                loop: true,
                navText: ['<span class="visually-hidden" aria-label="Previous Gallery Slide"></span>', '<span class="visually-hidden" aria-label="Next Gallery Slide"></span>'],
                autoplay: true,
                autoplayTimeout: 5000
            })
        })

    },

    gallery() {

        const _this = this
      
        _this.responsive_slides = []



        $('.content-block--gallery').each(function(){

            var el = this


            // let nav_container = $('.section-nav', $(el))

            // imagesLoaded( '#container', function() {
            // // images have loaded
            // });
            
            $(this).imagesLoaded().done(function() {

                // console.log(el)

                var num_items = $(el).hasClass('custom') ? 3 : 4
                num_items = $(el).hasClass('collection') ? 2 : num_items
                
                if ($(window).width() < 768 && $(el).hasClass('downloads')) {
                    var num_downloads = 1
                    num_items = 2
                }

                // console.log('oi::',$(el).find('.owl-item:not(.cloned)').length > 1)

                $('.owl-carousel', el).owlCarousel({
                    items: 1,
                    nav: $(el).find('.owl-item:not(.cloned)').length > 1,
                    dots: false,
                    autoHeight: false,
                    loop: $(el).find('.owl-item:not(.cloned)').length > 1,
                    // margin: 6,
                    // autoplay:true,
                    // autoplayTimeout:5000,
                    // autoplayHoverPause:true,
                    // navContainer: nav_container,
                    navText: ['<span class="icon-left icon-chevron-large-left" aria-label="Previous Gallery Slide"></span>', '<span class="icon-right icon-chevron-large-right" aria-label="Next Gallery Slide"></span>'],
                    responsive:{
                      0:{
                        items: 1,
                        loop: false,
                      },
                      
                      768:{
                        // center:true,
                        items: 2,
                        loop: $(el).find('.owl-item:not(.cloned)').length > 2,
                        nav: $(el).find('.owl-item:not(.cloned)').length > 2,
                        autoWidth:false,
                      }
                    }
                })

                $(window).trigger('resize')
                _this._onWindowResize()
            })

        })


        $('.results').each(function(){

            var el = this
            
            if ($(window).width() > 768) {
              return false
            }

            $(this).imagesLoaded().done(function() {

              console.log(el)


                var results = $('.owl-carousel', el).owlCarousel({
                    items: 1,
                    nav: true,
                    dots: false,
                    autoHeight: false,
                    loop: $('.card', el).length >= 1 ? true : false,
                    margin: 6,
                    // autoplay:true,
                    // autoplayTimeout:5000,
                    // autoplayHoverPause:true,
                    // navContainer: nav_container,
                    navText: ['<span class="icon-left icon-carousel-arrow"></span>', '<span class="icon-right icon-carousel-arrow"></span>'],
                    responsive:{
                      0:{
                        items: 2,
                        loop: $('.card', el).length > 2 ? true : false,
                      },
                      
                      768:{
                        // center:true,
                        items: 3,
                        loop: $('.card', el).length > 2 ? true : false,
                        nav: true,
                        autoWidth:false,
                      }
                    }
                })

                _this.responsive_slides.push(results)
            })

        })
    
    },

    carousels() {

        var _this = this

        $('.join-in-carousel-carousel-wrap').each(function(){
            var el = this            

            $(el).imagesLoaded().done(function() {

                console.log(el)

                var num_items = $(el).hasClass('custom') ? 3 : 4
                num_items = $(el).hasClass('collection') ? 2 : num_items
                
                if ($(window).width() < 768 && $(el).hasClass('downloads')) {
                    var num_downloads = 1
                    num_items = 2
                }

                $('.owl-carousel', el).owlCarousel({
                    items: 1,
                    nav: true,
                    dots: false,
                    autoHeight: false,
                    loop: false,
                    // margin: 6,
                    // autoplay:true,
                    // autoplayTimeout:5000,
                    // autoplayHoverPause:true,
                    // navContainer: nav_container,
                    navText: ['<span class="icon-left icon-arrow-left diamond" aria-label="Previous Gallery Slide"></span>', '<span class="icon-right icon-arrow-right diamond" aria-label="Next Gallery Slide"></span>'],
                    responsive:{
                      0:{
                        items: 1,
                        loop: true,
                      },
                      
                      768:{
                        // center: true,
                        items: 4,
                        loop: false,
                        nav: true,
                        autoWidth: false,
                      }
                    }
                })
            })
        })

        $('#events-carousel-wrap').on('items-reloaded', ( e, r ) => {
            console.log($(e.currentTarget))
            console.log(r)
            $(e.currentTarget).html(r)

            _this.events_carousel_wrap_slideshow();
        })
        

        _this.events_carousel_wrap_slideshow()


        $('.featured-items--shop-wrap').each(function(){
            var el = this            

            $(el).imagesLoaded().done(function() {

                console.log(el)

                var num_items = $(el).hasClass('custom') ? 3 : 4
                num_items = $(el).hasClass('collection') ? 2 : num_items
                
                if ($(window).width() < 768 && $(el).hasClass('downloads')) {
                    var num_downloads = 1
                    num_items = 2
                }

                $('.owl-carousel', el).owlCarousel({
                    items: 1,
                    nav: true,
                    dots: false,
                    autoHeight: false,
                    loop: true,
                    center: true,
                    // margin: 6,
                    // autoplay:true,
                    // autoplayTimeout:5000,
                    // autoplayHoverPause:true,
                    // navContainer: nav_container,
                    navText: ['<span class="icon-left icon-chevron-large-left" aria-label="Previous Product"></span>', '<span class="icon-right icon-chevron-large-right" aria-label="Next Product"></span>'],
                    // responsive:{
                    //   0:{
                    //     items: 1,
                    //     loop: true,
                    //   },
                      
                    //   768:{
                    //     // center: true,
                    //     items: 4,
                    //     loop: false,
                    //     nav: true,
                    //     autoWidth: false,
                    //   }
                    // }
                })
            })
        })

    },

    events_carousel_wrap_slideshow() {

        $('.events-carousel-wrap').each(function(){
            var el = this            

            $(el).imagesLoaded().done(function() {

                console.log(el)

                var num_items = $(el).hasClass('custom') ? 3 : 4
                num_items = $(el).hasClass('collection') ? 2 : num_items
                
                if ($(window).width() < 768 && $(el).hasClass('downloads')) {
                    var num_downloads = 1
                    num_items = 2
                }

                $('.owl-carousel', el).owlCarousel({
                    items: 1,
                    nav: true,
                    dots: false,
                    autoHeight: false,
                    loop: false,
                    // margin: 6,
                    // autoplay:true,
                    // autoplayTimeout:5000,
                    // autoplayHoverPause:true,
                    // navContainer: nav_container,
                    navText: ['<span class="icon-left icon-arrow-left diamond" aria-label="Previous Gallery Slide"></span>', '<span class="icon-right icon-arrow-right diamond" aria-label="Next Gallery Slide"></span>'],
                    responsive:{
                      0:{
                        items: 1,
                        loop: true,
                      },
                      
                      768:{
                        // center:true,
                        items: 2,
                        loop: false,
                        nav: true,
                        autoWidth: false,
                      }
                    }
                })
            })
        })
    },


    _onWindowResize(e) {

        let w = window.innerWidth,
            h  = window.innerHeight


        $('.image-deco').each( (index, el) => {
            let $i = $(this)

            let $el = $(el)
            // console.log($el)
            if ( $el.hasClass('ratio-3-2') ) {
                $el.height( $el.width() * 2/3 )
            }

            if ( $el.hasClass('ratio-1-1') ) {
                $el.height( $el.width() * 1 )
            }

            if ( $el.hasClass('ratio-1-1') ) {
                $el.height( $el.width() * 1 )
            }

            if ( $el.hasClass('ratio-3-4') ) {
                $el.height( $el.width() * 4/3 )
            }

            if ( $el.hasClass('ratio-4-3') ) {
                $el.height( $el.width() * 3/4 )
            }

            if ( $el.hasClass('ratio-16-9') ) {
                $el.height( $el.width() * 9/16 )
            }

            // if ( $el.data('src') && !$el.hasClass('rendered') ) { 
            //     let src = $el.data('src')
            //     $el.css({
            //         'background-image': `url(${src})`
            //     })
            //     $el.addClass('rendered')
            // }


            $('.bg-resize').each(function(){
                var $imgs = $('img, video, iframe', this); 
                var $container = $(this);
                $imgs.each(function(){

                    var $img = $(this),
                        imgOriginalWidth = $img.attr('data-width'),
                        imgOriginalHeight = $img.attr('data-height'),
                        containerWidth = $container.width(),
                        containerHeight = $container.height(),
                        newW = 0,
                        newH = 0,
                        offsetTop = 0,
                        offsetLeft = 0;
                    if ( imgOriginalWidth && imgOriginalHeight )
                    {
                        var imgOriginalRatio = imgOriginalHeight / imgOriginalWidth;
                        newW = containerWidth;
                        newH = newW * imgOriginalRatio;
                        if ( $img.closest('.bg-resize').hasClass('bg-fit') )
                        {
                            if ( newH > containerHeight )
                            {
                                newH = containerHeight;
                                newW = newH / imgOriginalRatio;
                                offsetLeft = parseInt( ( - newW + containerWidth ) / 2 );
                            } else {
                                offsetTop = parseInt( ( - newH + containerHeight ) / 2 );
                            }    
                            $img.css({
                                width: newW + 'px',
                                height: newH + 'px',
                                // marginLeft: offsetLeft + 'px',
                                // marginTop: ( offsetTop < 0 ? offsetTop : offsetTop ) + 'px'
                            });
                        } else {
                            if ( newH < containerHeight )
                            {
                                newH = containerHeight;
                                newW = newH / imgOriginalRatio;
                                offsetLeft = parseInt( ( - newW + containerWidth ) / 2 );
                            } else {
                                offsetTop = parseInt( ( - newH + containerHeight ) / 2 );
                            }    
                            
                            $img.css({
                                width: newW + 'px',
                                height: newH + 'px',
                                marginLeft: offsetLeft + 'px',
                                marginTop: ( offsetTop < 0 ? offsetTop : offsetTop ) + 'px'
                            });
                        }
                        // console.log($img)

                        $img.hasClass('loaded') || $img.addClass('loaded')
                        
                    }
                })
                
                
            })

        })

      // for(const item of this.responsive_slides){
      //   item.trigger('destroy.owl.carousel')
      // }



      // this.gallery()

      // console.log(this.client_slides)
    },


  // session: function() {

  //   setTimeout(function(){

  //     var spektrix_customer = localStorage.getItem('spektrixCustomer')

  //     if (spektrix_customer) {

  //       var spektrix_data = JSON.parse(spektrix_customer)

  //       if (!spektrix_data.data.email) {

  //         $.get(window.ajax_client.ajax_url, {
  //             'action': 'spektrix_session',
  //             'spektrix_customer': null
  //         }, function(response){
  //             Cookies.remove('spektrix_customer')
  //         })
  //       }
  //     }

  //   }, 1000)
    
  // },


  

    render() {

        const _this = this    

        _this.gallery()

        _this.quotes()

        _this.carousels()

        // if ( $('#visit-map').length ) {
        //     let map = new VisitMap()
        //     map.render()
        // }
    
        // this.session()

        $('html').removeClass('no-js')
        if ('ontouchstart' in document.documentElement){
            $('html').removeClass('no-touch')
        }

        if ( _this.$el.hasClass('spektrix-page') ) {

            var iframe = document.getElementById('SpektrixIFrame')
            var message = {
                path: location.pathname
            }

            iframe.addEventListener( 'load', function(e) {
                iframe.contentWindow.postMessage(message, '*')

                console.log('post message')
            })
            
        }
    
        let common_view = new CommonView()
        common_view.render()

        // let video_view = new VideoView()
        // video_view.render()

        let premium_view = new PremiumView()
        premium_view.render()
        
        let video_view = new VideoView()
        // let premium_view = new PremiumView()
        // let illustration_view = new IllustrationView()
        

        // let animation_view = new AnimationView()

        // if ($('.modal-booking').length) {
          // let bookings_view = new BookingsView()
        // }

        // if ($('body').hasClass('page-template-whats-on')) {
        //   let events_view = new EventsView()
        // }
        
        // let events_view = new EventsView()

        // if ($('body').hasClass('single-festival')) {
        //   let events_view = new EventsView()
        // }
        
        // $(document).ready(function() {
          
        // })


        let lang_opt  = Cookies.get('lang_opt')
        if ( ajax_client.current_lang == 'en' && !lang_opt) {
            _this.$el.addClass('ui-language-modal-on')
        }


        let cookies_consent = Cookies.get('cookies-consent')
        if (! cookies_consent ) {
            this.$el.addClass('ui-cookies-banner-on')
        }

    
    }
})

export default AppView